import HeaderFFF from "../../../components/HeaderFFF";
import Header from '../../../components/Header'
import React, { useEffect, useState } from 'react';
import Footer from "../../../components/Footer";
import { Link } from 'react-router-dom';
import '../../../styles/injury.css'

export default function AccidentBenefit() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Accident Benefit Claims</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
            </div>
            <div className="pi-text">
                <p>When car accidents occur, an <b>accident benefits lawyer in Toronto </b>can help secure victims the
compensation they are entitled to.<br></br><br></br>
Many people involved in car accidents do not realize that they may be entitled to statutory
accident benefits in Ontario, even if they were at fault. Using an accident benefits lawyer can
ensure that they are not denied the benefits and that they receive the compensation needed for
covering expenses and promoting recovery.<br/><br/>
<span className="pi-sub-section">What Are Accident Benefits?</span><br/><br/>
When people are involved in car accidents, they are entitled to accident benefits from their
insurance providers. Accidents benefits provide compensation to people who have been injured
or harmed in car accidents, as well as to passengers and other injured parties. In Ontario, the
Statutory Accidents Benefit Schedule (SABS) regulates the benefits that insurers have to
provide following an auto collision.<br/><br/>
Statutory accident benefits can cover medical expenses, rehabilitative costs, income
replacement costs, and attendant care expenses, along with other associated costs and
expenses. Statutory accident benefits are provided to victims regardless of fault, negligibility,
and liability.<br/><br/>
<b>Statutory Accident Benefits Coverage in Ontario</b><br/><br/>

In Ontario, auto accident benefits are regulated and standardized by the government. Statutory
accident benefits offer the following coverage to people injured in car accidents in Ontario:<br/><br/>
<b>Income Replacement Benefit</b><br/><br/>
The income replacement benefit offers financial assistance to individuals who are unable to
work due to their injury. An injured person is entitled to 70% of their gross income, up to the limit
of $400.00 each week.<br/><br/>
<b>Non-Earner Benefit</b><br/><br/>
Individuals who have been injured in a car accident who are unemployed or who are a student
may be entitled to this benefit, although documentation may be needed to receive this benefit.<br/><br/>
<b>Attendant Care Benefit</b><br/><br/>
If your impairment is classified to be outside of the minor injury then you may qualify to receive
personal care services.<br/><br/>

<b>Housekeeping and Home Maintenance Benefit</b><br/><br/>
An optional benefit also available to an injured person is the housekeeping and home
maintenance benefit, which provides reimbursement for housekeeping and home maintenance
expenses of up to $100.00 per week, if an injury has affected an individual’s ability to maintain
their home or perform certain essential tasks.<br/><br/>
<b>Caregiver Benefit</b><br/><br/>
The caregiver benefit is for victims who sustain a catastrophic impairment and who were the
primary caregiver for a person in need of care.<br/><br/>
If an injured person is a caregiver and has dependents, they are entitled to up to $250.00 a
week for the first dependent and a subsequent $50.00 per week for each additional dependent.<br/><br/>
<b>Accident Benefits Lawyer</b><br/><br/>
When a person has suffered an injury in a car accident in Ontario, they are entitled to
standardized accident benefits. However, when a person is filing for an accident benefits claim
in Ontario, they may have trouble securing the assistance they are entitled to or may be denied
further treatment under the MIG.<br/><br/>
At <b>CLV</b>, we are experienced in representing injured clients following car accidents and in
reaching accident benefits settlements in Ontario with insurance providers. Our personal injury
lawyers always strive to secure the maximum possible compensation for our clients and to
reach a successful settlement as quickly as possible, allowing them to continue with their
recovery. We have experience dealing with insurance providers and ensuring that our clients
receive effective legal representation.<br/><br/>

To arrange a Free consultation, <Link to="/contact-us">contact us</Link> today.</p>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
            </div>
        </div>
            <Footer />
        </>
        );
}